/**
 * @generated SignedSource<<be4c1ad6e9e50a3cdf629a4c22f90575>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DelegatesOrder = "mostDelegates" | "mostVotes" | "mostVotesMostPower" | "mostVotingPower" | "random" | "%future added value";
export type StatementFilter = "allStatements" | "withStatement" | "withoutStatement" | "%future added value";
export type TopIssuesFilter = "metagovernance" | "protocol" | "treasury" | "%future added value";
export type TopStakeholdersFilter = "builder" | "communityMember" | "liquidityProvider" | "trader" | "%future added value";
export type HomePageRouteQuery$variables = {
  orderBy: DelegatesOrder;
  seed: string;
  statement?: StatementFilter | null;
  topIssues?: TopIssuesFilter | null;
  topStakeholders?: TopStakeholdersFilter | null;
};
export type HomePageRouteQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DelegatesContainerFragment" | "OverviewMetricsContainerFragment">;
};
export type HomePageRouteQuery = {
  response: HomePageRouteQuery$data;
  variables: HomePageRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "seed"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "statement"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topIssues"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topStakeholders"
},
v5 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v6 = {
  "kind": "Variable",
  "name": "seed",
  "variableName": "seed"
},
v7 = {
  "kind": "Variable",
  "name": "statement",
  "variableName": "statement"
},
v8 = {
  "kind": "Variable",
  "name": "topIssues",
  "variableName": "topIssues"
},
v9 = {
  "kind": "Variable",
  "name": "topStakeholders",
  "variableName": "topStakeholders"
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "fields": [
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v11 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "decimals",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  }
],
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "TokenAmount",
  "kind": "LinkedField",
  "name": "amount",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v13 = [
  (v12/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "bpsOfStakedSupply",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomePageRouteQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "DelegatesContainerFragment"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "OverviewMetricsContainerFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomePageRouteQuery",
    "selections": [
      {
        "alias": "voters",
        "args": (v10/*: any*/),
        "concreteType": "DelegatesConnection",
        "kind": "LinkedField",
        "name": "delegates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DelegatesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Delegate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ResolvedName",
                        "kind": "LinkedField",
                        "name": "resolvedName",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "address",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DelegateStatement",
                    "kind": "LinkedField",
                    "name": "statement",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "summary",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "twitter",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "discord",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VotingPower",
                    "kind": "LinkedField",
                    "name": "tokensRepresentedVote",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "voters",
        "args": (v10/*: any*/),
        "filters": [
          "seed",
          "where",
          "orderBy"
        ],
        "handle": "connection",
        "key": "DelegatesContainerFragment_voters",
        "kind": "LinkedHandle",
        "name": "delegates"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Metrics",
        "kind": "LinkedField",
        "name": "metrics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TokenAmount",
            "kind": "LinkedField",
            "name": "stakedSupply",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TokenAmount",
            "kind": "LinkedField",
            "name": "totalSupply",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VotingPower",
            "kind": "LinkedField",
            "name": "quorumShortTimelock",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VotingPower",
            "kind": "LinkedField",
            "name": "quorumLongTimelock",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VotingPower",
            "kind": "LinkedField",
            "name": "thresholdShortTimelock",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VotingPower",
            "kind": "LinkedField",
            "name": "thresholdLongTimelock",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b393a8483109ce260a3c7530190dfef4",
    "id": null,
    "metadata": {},
    "name": "HomePageRouteQuery",
    "operationKind": "query",
    "text": "query HomePageRouteQuery(\n  $orderBy: DelegatesOrder!\n  $seed: String!\n  $topStakeholders: TopStakeholdersFilter\n  $topIssues: TopIssuesFilter\n  $statement: StatementFilter\n) {\n  ...DelegatesContainerFragment_2dbm2i\n  ...OverviewMetricsContainerFragment\n}\n\nfragment DelegateProfileImageFragment on Delegate {\n  address {\n    resolvedName {\n      address\n      ...NounResolvedNameFragment\n      ...ENSAvatarFragment\n    }\n  }\n  tokensRepresentedVote {\n    amount {\n      ...TokenAmountDisplayFragment\n    }\n  }\n}\n\nfragment DelegatesContainerFragment_2dbm2i on Query {\n  voters: delegates(first: 30, seed: $seed, where: {topIssues: $topIssues, topStakeholders: $topStakeholders, statement: $statement}, orderBy: $orderBy) {\n    edges {\n      node {\n        id\n        ...VoterCardFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ENSAvatarFragment on ResolvedName {\n  name\n}\n\nfragment NounResolvedNameFragment on ResolvedName {\n  address\n  name\n}\n\nfragment OverviewMetricsContainerFragment on Query {\n  metrics {\n    stakedSupply {\n      amount\n      ...TokenAmountDisplayFragment\n    }\n    totalSupply {\n      amount\n      ...TokenAmountDisplayFragment\n    }\n    quorumShortTimelock {\n      amount {\n        ...TokenAmountDisplayFragment\n      }\n      bpsOfStakedSupply\n    }\n    quorumLongTimelock {\n      amount {\n        ...TokenAmountDisplayFragment\n      }\n      bpsOfStakedSupply\n    }\n    thresholdShortTimelock {\n      amount {\n        ...TokenAmountDisplayFragment\n      }\n      bpsOfStakedSupply\n    }\n    thresholdLongTimelock {\n      amount {\n        ...TokenAmountDisplayFragment\n      }\n      bpsOfStakedSupply\n    }\n  }\n}\n\nfragment TokenAmountDisplayFragment on TokenAmount {\n  amount\n  decimals\n  currency\n}\n\nfragment VoterCardFragment on Delegate {\n  address {\n    resolvedName {\n      address\n      name\n    }\n  }\n  statement {\n    summary\n  }\n  ...VoterPanelActionsFragment\n  ...DelegateProfileImageFragment\n}\n\nfragment VoterPanelActionsDelegateButtonFragment on Delegate {\n  address {\n    resolvedName {\n      address\n    }\n  }\n}\n\nfragment VoterPanelActionsFragment on Delegate {\n  statement {\n    twitter\n    discord\n  }\n  ...VoterPanelActionsDelegateButtonFragment\n}\n"
  }
};
})();

(node as any).hash = "6e9798e27705500ce16ebd4f1e9af4b9";

export default node;
